// extracted by mini-css-extract-plugin
export default {"supply__types":"SupplyTypes_supply__types__jaFm1","input":"SupplyTypes_input__2ytwL"};